<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1" stepTitle="图文详情及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">商品详情</span>
            </a-col>
          </a-row>
          <p class="tips">如果上传本地图片，图片大小应小于1M，图片格式为.jpg .png。</p>
          <CustomUeditor v-model="proDes"></CustomUeditor>
          <a-row style="margin-top:20px;">
            <a-button type="primary" :disabled="proSource!=0" @click="submitData" :loading="submitLoading">
              提交并下一步
            </a-button>
            <a-button v-if="proId!=0" @click="goEvent" style="margin-left: 10px">下一步</a-button>
          </a-row>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import PublishPro from '../components/PublishPro'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'

export default {
  name: 'TravelProDes',
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro,
    CustomUeditor
  },
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      proDes: '',
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      submitFormData: ''
    }
  },
  mounted() {
    this.getProDes()
  },
  methods: {
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getProService().post('product/info/saveTourGraphic', {
        proId: this.proId,
        proDes: this.proDes
      }).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('商品详情保存成功')
        setTimeout(() => {
          this.goEvent()
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getProDes() {
      this.getHttpServices().getProService().get('product/info/getTourGraphic?proId=' + this.proId).then(res => {
        // this.getLogUtils().logWithTag("getProVisaDes",res)
        this.proDes = res ? res : ''
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goEvent() {
      let name = ''
      if (this.proSource == 0) {
        name = 'ProOwnPrice'
      } else {
        name = 'ProNoOwnPrice'
      }
      this.$router.push({
        name,
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>